// extracted by mini-css-extract-plugin
export var border = "TestimonialCard-module--border--7b27f";
export var content = "TestimonialCard-module--content--8c68a";
export var from = "TestimonialCard-module--from--68ee7";
export var hasPost = "TestimonialCard-module--hasPost--4f7cf";
export var link = "TestimonialCard-module--link--0d9e1";
export var linkIcon = "TestimonialCard-module--linkIcon--f8c33";
export var logoC = "TestimonialCard-module--logoC--7a72c";
export var postC = "TestimonialCard-module--postC--0d3aa";
export var quote1 = "TestimonialCard-module--quote1--47f89";
export var quote2 = "TestimonialCard-module--quote2--6da08";
export var root = "TestimonialCard-module--root--daa0b";